// extracted by mini-css-extract-plugin
module.exports = {"error-content":"error-content-1wEvl3J","icon":"icon-1EVX2Nx","message":"message-2ncCclt"};